import withModal from '@mdigital/components/dist/hoc/ModalHoc';
import { getSingleText } from '../../../common/utils';
import { CommonModal } from '../common';

const basicModalProps = {
  title: getSingleText('app.pages.forms.folders.modals.create.newFolder'),
  okButtonText: getSingleText('app.pages.forms.folders.modals.create.createFolder'),
  cancelButtonText: getSingleText('app.pages.forms.folders.modals.create.cancel'),
  okButtonClass: 'btn-success',
  modalClassName: 'modal-design',
};

@withModal(basicModalProps)
export default class CreateFolderModal extends CommonModal {
  constructor(props) {
    super(props);
  }
}